import React, { SVGProps } from 'react';

const SparkleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.5 4.5Q9.3 10.7 15.5 11.5Q9.3 12.3 8.5 18.5Q7.7 12.3 1.5 11.5Q7.7 10.7 8.5 4.5ZM16 1Q16.4 3.6 19 4Q16.4 4.4 16 7Q15.6 4.4 13 4Q15.6 3.6 16 1Z"
      fill={props.fill ? props.fill : '#73A3FF'}
    />
  </svg>
);

export default SparkleIcon;
